import React from 'react';
import { Page, Document, Image, StyleSheet } from '@react-pdf/renderer';
import CompanyInfo from "./Components/CompanyInfo";
import DirectorItemsTable from "./Components/DirectorItemsTable";
import RegisterTitle from "../general/RegisterTitle";

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 11,
        paddingTop: 30,
        paddingLeft:60,
        paddingRight:60,
        lineHeight: 1.5,
        flexDirection: 'column',
    }, 
    logo: {
        width: 74,
        height: 66,
        marginLeft: 'auto',
        marginRight: 'auto'
    }
  });
  
  const DirectorRegister = ({directors}) => (
            <Document>
                <Page size="A4" style={styles.page} orientation="landscape">
                    <RegisterTitle title='Director Register'/>
                    <CompanyInfo directors={directors}/>
                    <DirectorItemsTable directors={directors} />
                </Page>
            </Document>
        );
  
  export default DirectorRegister